import React, { useEffect, useState } from 'react'

import Heading from 'components/Heading'
import Button from 'components/Button'

import styles from '../Signup.module.css'

const ChooseProfile = ({ setValue, handleSubmit }) => {
  const setType = (type) => {
    setValue('profile_type', type)
    setValue('step', 'profile')
    handleSubmit()
  }

  return (
    <div className={styles['step-wrapper']}>
      <Heading element="h3" bold center>
        Get Started
      </Heading>
      <div className={styles['choose-profile-wrapper']}>
        <div className={styles['choose-profile-button']}>
          <Button buttonElement primary centered onClick={() => setType('personal')}>
            Create A Personal Profile
          </Button>
        </div>
        <div className={styles['choose-profile-button']}>
          <Button buttonElement primary centered onClick={() => setType('business')}>
            Create A Business Profile
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ChooseProfile
